import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import BoxWithIcon from "../atoms/ComponentBox/BoxWithIcon";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectPermissions } from "../redux/permissionsSlice";
import fetchStatusCounts from "../GlobalFunction/Counts";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

const GstCode = () => {
  const [counts, setCounts] = useState([]);

  const permissions = useSelector(selectPermissions);

  const hasModulePermission = (moduleName) => {
    const modulePermission = permissions.find(
      (permission) => permission.ModuleName === moduleName
    );

    if (!modulePermission) return false;

    return (
      modulePermission.AddRec === "1" ||
      modulePermission.EditRec === "1" ||
      modulePermission.DeleteRec === "1" ||
      modulePermission.ViewRec === "1"
    );
  };

  const parentId = 40;

  useEffect(() => {
    const getCounts = async () => {
      const data = await fetchStatusCounts(parentId);
      setCounts(data);
    };
    getCounts();
  }, [parentId])

  const matchedItem = (moduleName) => {
    return counts.find(item => item.ModuleName === moduleName);
  };

  const matchhsncode = matchedItem('HSN/SAC Code');
  const matchgstchapterheading = matchedItem('Gst Chapter Heading')
  const matchgstsubchapterheading = matchedItem('Gst SubChapter Heading');

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid
        container
        sx={{
          width: "100%",
          maxWidth: "100%"
        }}
      >
        <Grid item xs={12}>
          <Grid container spacing={1}>
            {hasModulePermission("HSN/SAC Code") && (
              <BoxWithIcon
                totalCount={10}
                activeCount={10}
                inactiveCount={10}
                link={{ pathname: "/hsn-code-table" }}
                permissions={permissions}
                title="HSN/SAC Code"
              />
            )}
            {hasModulePermission("Gst Chapter Heading") && (
              <BoxWithIcon
                totalCount={10}
                activeCount={10}
                inactiveCount={10}
                link={{ pathname: "/gst-chapter-heading-table" }}
                title="Gst Chapter Heading"
              />
            )}
            {hasModulePermission("Gst Sub Chapter Heading") && (
              <BoxWithIcon
                totalCount={10}
                activeCount={10}
                inactiveCount={10}
                link={{ pathname: "/gst-sub-chapter-heading-table" }}
                permissions={permissions}
                title="Gst Sub Chapter Heading"
              />
            )}

          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default GstCode;
